
var space = require('to-space-case')

/**
 * Export.
 */

module.exports = toCapitalCase

/**
 * Convert a `string` to capital case.
 *
 * @param {String} string
 * @return {String}
 */

function toCapitalCase(string) {
  return space(string).replace(/(^|\s)(\w)/g, function (matches, previous, letter) {
    return previous + letter.toUpperCase()
  })
}



//////////////////
// WEBPACK FOOTER
// ../~/to-capital-case/index.js
// module id = 3043
// module chunks = 0